import {Section} from "./Section";
import {AsideLeft} from "./AsideLeft";
import {AsideRight} from "./AsideRight";
import {Col, Row} from "react-bootstrap";
import PropTypes from "prop-types";

export function BasePageLayout(props) {
    const {title, children, className} = props;
    return <Section className={`pt-2 justify-content-between ${className}`} style={{minHeight: "90vh"}}>
        <Col xs={12} lg={2} className={'rounded border shadow order-1 order-lg-0'} style={{backgroundColor: 'white'}}>
            <AsideLeft/>
        </Col>
        <Col xs={12} lg={7} className={'order-0 order-lg-1 rounded border shadow'} style={{backgroundColor: 'white'}}>
            <Section className={"px-2 pt-2"} title={title ? title : ''}>
                {children}
            </Section>
        </Col>
        <Col xs={12} lg={2} className={'rounded border shadow  order-2 order-lg-2'} style={{backgroundColor: 'white'}}>
            <AsideRight/>
        </Col>
    </Section>
}

BasePageLayout.propTypes = {
    title: PropTypes.string,
    children: PropTypes.any,
    className: PropTypes.string
}